module.exports = __webpack_public_path__ + "img/021.c2bac7cf.jpg";